import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["blType", "quantity"];

  connect() {
    $("#carrier_booking_document_detail_bl_type").on("select2:select", function () {
      let event = new Event("change", { bubbles: true }); // fire a native event
      this.dispatchEvent(event);
    });

    this.changed();
  }

  changed() {
    switch (this.blTypeTarget.value) {
      case "sea_way_bill":
        this.quantityTarget.value = 0;
        break;
      case "bill_of_lading_original":
        this.quantityTarget.value = 3;
        break;
      case "bill_of_lading_copy":
        this.quantityTarget.value = 6;
        break;
    }
  }
}
